import { API_BASE } from '../config/api';

async function parseJsonResponse(response) {
  const payload = await response.json().catch(() => null);

  if (!response.ok) {
    const message = payload?.message || `Request failed (${response.status})`;
    throw new Error(message);
  }

  if (!payload?.success) {
    throw new Error(payload?.message || 'Unexpected API response');
  }

  return payload.data;
}

export async function apiGet(path, params = {}) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const url = API_BASE.startsWith('http://') || API_BASE.startsWith('https://')
    ? new URL(`${API_BASE}${normalizedPath}`)
    : new URL(`${API_BASE}${normalizedPath}`, window.location.origin);

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      url.searchParams.set(key, String(value));
    }
  });

  let response;
  try {
    response = await fetch(url.toString(), {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      cache: 'no-store',
    });
  } catch (error) {
    const detail = error?.message || 'Network request failed';
    throw new Error(
      `Unable to reach the catalogue API (${detail}). Please refresh and try again.`,
    );
  }

  return parseJsonResponse(response);
}

export { API_BASE };
